import { call, takeEvery } from 'redux-saga/effects';
import { GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { ToolbarActions } from '../toolbar.actions';

export enum LOGOUTREQUEST_EVENTS {
  REQUEST_LOGOUT_SUCCESS = 'REQUEST_LOGOUT_SUCCESS',
  REQUEST_LOGOUT_FAILED = 'REQUEST_LOGOUT_FAILED',
}

export function* logoutSaga() {
  yield takeEvery(ToolbarActions.REQUEST_LOGOUT, safeSaga(requestLogout, App.SHOP_TOOLBAR));
  yield takeEvery(
    LOGOUTREQUEST_EVENTS.REQUEST_LOGOUT_SUCCESS,
    safeSaga(handleResponse, App.SHOP_TOOLBAR),
  );
}

export function* requestLogout() {
  const url = '/privatschutz/api/logout';

  const globalPut = GlobalPut.getInstance();
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().doRequest({
      appId: App.SHOP_TOOLBAR,
      url,
      successEvent: LOGOUTREQUEST_EVENTS.REQUEST_LOGOUT_SUCCESS,
      errorEvent: LOGOUTREQUEST_EVENTS.REQUEST_LOGOUT_FAILED,
    }),
  );
}

export function* handleResponse() {
  const globalPut = GlobalPut.getInstance();
  yield call([globalPut, globalPut.put], new GlobalActions().userLoggedOut());
}
